/**
 * Foto-Kacheln (photo-tiles): Punkt-Navigation für horizontalen Slider.
 */
(function () {
  'use strict';

  function syncActiveFromScroll(slider, slides, dots) {
    if (!slides.length || !dots.length) return;

    const sRect = slider.getBoundingClientRect();
    const viewCenter = (sRect.left + sRect.right) / 2;

    let bestIdx = 0;
    let bestDist = Infinity;

    slides.forEach((slide, i) => {
      const r = slide.getBoundingClientRect();
      const mid = (r.left + r.right) / 2;
      const dist = Math.abs(mid - viewCenter);
      if (dist < bestDist) {
        bestDist = dist;
        bestIdx = i;
      }
    });

    const i = Math.max(0, Math.min(bestIdx, dots.length - 1));
    dots.forEach((dot, j) => {
      const active = j === i;
      dot.classList.toggle('photo-tiles__dot--active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function photoTilesDotsInit(root) {
    if (!root || root.dataset.photoTilesDotsInit === 'true') return;

    const slider = root.querySelector('[id^="Slider-"]');
    const dots = root.querySelectorAll('.photo-tiles__dot');
    const slides = root.querySelectorAll('[id^="Slide-"]');
    if (!slider || !dots.length || !slides.length) return;

    root.dataset.photoTilesDotsInit = 'true';

    const sync = () => syncActiveFromScroll(slider, slides, dots);

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        sync();
      });
    };

    slider.addEventListener('scroll', onScroll, { passive: true });
    slider.addEventListener('scrollend', onScroll, { passive: true });
    root.addEventListener('slideChanged', () => requestAnimationFrame(sync));

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const target = slides[i];
        if (!target) return;
        target.scrollIntoView({
          behavior: 'smooth',
          inline: 'start',
          block: 'nearest',
        });
        requestAnimationFrame(() => requestAnimationFrame(sync));
      });
    });

    const ro = new ResizeObserver(() => sync());
    ro.observe(slider);

    sync();
    requestAnimationFrame(sync);
    requestAnimationFrame(() => requestAnimationFrame(sync));
  }

  function setupAllPhotoTilesDots() {
    document.querySelectorAll('.photo-tiles__slider-component').forEach(photoTilesDotsInit);
  }

  if (!window.__kkPhotoTilesDotsInstalled) {
    window.__kkPhotoTilesDotsInstalled = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAllPhotoTilesDots, { once: true });
    } else {
      setupAllPhotoTilesDots();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target || typeof event.target.querySelectorAll !== 'function') return;
      event.target.querySelectorAll('.photo-tiles__slider-component').forEach(photoTilesDotsInit);
    });
  } else {
    setupAllPhotoTilesDots();
  }
})();
